import { useState, useEffect, useCallback, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  PdfLoader,
  PdfHighlighter,
  Tip,
  Highlight,
  Popup,
  AreaHighlight,
} from "react-pdf-highlighter";
import { Spinner } from "./Spinner";
import { SpinnerModal } from "./SpinnerModal";
import { Sidebar } from "./Sidebar";

import { Row, Col, Modal, Button as RButton } from "react-bootstrap";

import api from "../../services/api";
import { toast } from "react-toastify";
import { useCompetencia } from "../../context/competencia";

import CaixaDeCorrecao from "./CaixaDeCorrecao";
import { useAuth } from "../../context/auth";
import { Navigate } from "styled-icons/ionicons-solid";

// Função para detectar e converter links em texto
const linkifyText = (text) => {
  if (!text) return text;
  
  // Regex para detectar URLs (incluindo http, https, www e domínios simples)
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;
  
  const parts = text.split(urlRegex);
  
  return parts.map((part, index) => {
    if (urlRegex.test(part)) {
      // Garantir que o link tem protocolo
      let url = part;
      if (!part.startsWith('http://') && !part.startsWith('https://')) {
        url = 'https://' + part;
      }
      
      return (
        <a 
          key={index}
          href={url} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#007bff',
            textDecoration: 'underline',
            cursor: 'pointer'
          }}
          onClick={(e) => e.stopPropagation()} // Evitar que o clique no link interfira com outros eventos
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

const HighlightPopup = ({ comment }) =>
  comment.text ? (
    <div className="Highlight__popup">
      {linkifyText(comment.text)}
    </div>
  ) : null;

const CarregarPDF = (props) => {
  const { pdf, setFixo, competencia, id, tipo } = props;

  const history = useHistory();

  const { user } = useAuth();

  const { setCompetencia } = useCompetencia();

  const [att, setAtt] = useState(new Date());
  const [highlights, setHighlights] = useState([]);
  const [show, setShow] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [show2, setShow2] = useState(true);
  const [aberto, setAberto] = useState(false);

  const [anterior, setAnterior] = useState();
  const [proximo, setProximo] = useState();

  // Dimensões do PDF - agora usamos para referência apenas
  const PDF_WIDTH = 800;
  const PDF_HEIGHT = 1200;

  // Novo estado para controle de edições locais
  const [localEdits, setLocalEdits] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  // Adicionar um novo estado para rastrear itens a serem removidos
  const [itemsParaRemover, setItemsParaRemover] = useState([]);
  
  // Adicionar um novo estado específico para marcações locais que ainda não foram salvas
  const [localHighlights, setLocalHighlights] = useState([]);
  
  // Adicionar um estado para controlar se a caixa de seleção está aberta
  const [selectionBoxOpen, setSelectionBoxOpen] = useState(false);

  // Estado para forçar re-render do PdfHighlighter
  const [pdfKey, setPdfKey] = useState(0);
  
  // Estado para controlar se o carregamento inicial foi concluído
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  // Informações da redação sendo corrigida
  const [redacaoInfo, setRedacaoInfo] = useState({ aluno: '', turma: '', tema: '' });

  /*
    Outras redações do mesmo aluno, para alternar entre elas sem voltar à listagem
    e refazer os filtros — que era o que o professor precisava fazer na monitoria.
  */
  const [redacoesDoAluno, setRedacoesDoAluno] = useState([]);
  const [buscaOutraRedacao, setBuscaOutraRedacao] = useState("");

  const inputEl = useRef(null);

  function handleClose() {
    // Se houver edições não salvas, pedir confirmação
    if (localEdits) {
      if (!window.confirm("Você tem alterações não salvas. Deseja realmente sair sem salvar?")) {
        return;
      }
    }
    
    document.body.classList.remove("shidden");
    setShow(false);
    setFixo(false);
  }

  /*
    Seletor de redações do aluno.

    Fora as que ainda não têm PDF enviado (`envio_pendente_aluno`): não há o que
    abrir nelas, é o mesmo motivo de a listagem não mostrar botão de correção.
  */
  const idAtual = String(window.location.pathname.split('/').pop() || id);

  const outrasRedacoesDoAluno = redacoesDoAluno.filter(
    (r) => String(r.id_redacao) !== idAtual && r.status !== 'envio_pendente_aluno'
  );

  // acima de 4 a lista rola dentro do bloco e ganha busca, em vez de esticar o painel
  const listaComprida = outrasRedacoesDoAluno.length > 4;

  const termoBusca = buscaOutraRedacao.trim().toLowerCase();
  const outrasRedacoesFiltradas = termoBusca
    ? outrasRedacoesDoAluno.filter((r) => (r.tema || '').toLowerCase().includes(termoBusca))
    : outrasRedacoesDoAluno;

  const trocarDeRedacao = (outroId) => {
    // mesma proteção do "fechar": marcação só existe no banco depois de salva
    if (localEdits && !window.confirm(
      "Você tem alterações não salvas nesta redação. Se trocar agora, elas serão perdidas. Deseja continuar?"
    )) {
      return;
    }

    /*
      `replace` para não empilhar uma entrada de histórico por redação visitada,
      senão o "voltar" exigiria um clique por troca até chegar na listagem.
    */
    history.replace(`/corrigir/redacao/${outroId}`, {
      voltarPara: history.location.state?.voltarPara,
    });
  };

  function addHighlight(highlight) {
    // ABORDAGEM SIMPLES: Salvar exatamente como recebemos, sem conversões
    // O react-pdf-highlighter já lida com responsividade internamente
    
    // IMPORTANTE: Como estamos ajustando a posição no onSelectionFinished,
    // aqui já recebemos a posição corrigida com o scroll offset
    console.log('💾 Salvando highlight (já com correção de scroll):', highlight);
    
    const highlightComId = {
      ...highlight,
      id: `local_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      // Marcar como nova correção sem mexer nas coordenadas
      novoSistema: true
    };
    
    console.log("✅ Nova marcação criada:", highlightComId);
    
    // Adicionar ao estado de marcações locais
    setLocalHighlights(prev => {
      const novoEstado = [...prev, highlightComId];
      console.log("📝 LocalHighlights atualizado:", novoEstado.length, "marcações");
      return novoEstado;
    });
    
    // Adicionar ao estado de todas as marcações
    setHighlights(prevState => {
      const novoEstado = [...prevState, highlightComId];
      console.log("📋 Highlights total atualizado:", novoEstado.length, "marcações");
      return novoEstado;
    });
    
    // Marcar que temos edições locais não salvas
    setLocalEdits(true);
    
    // Fechar a caixa de seleção
    setSelectionBoxOpen(false);
    
    toast.info("Competência adicionada. Clique em 'SALVAR TODAS AS MARCAÇÕES' quando terminar.");
  }

  const removerItem = (item) => {
    console.log("Ação de remoção/cancelamento para item:", item);
    
    // Verificar se o item já está marcado para remoção (tanto local quanto servidor)
    const jaEstaParaRemover = itemsParaRemover.includes(String(item));
    
    if (jaEstaParaRemover) {
      // CANCELAR a remoção - remover da lista de itens para remover
      console.log("🔄 Cancelando remoção do item:", item);
      
      setItemsParaRemover(prev => prev.filter(id => id !== String(item)));
      
      // Remover a marca visual de "marcado para remoção"
      setHighlights(prevHighlights => {
        return prevHighlights.map(h => {
          if (String(h.id) === String(item)) {
            const { marcadoParaRemocao, ...highlightSemMarca } = h;
            return highlightSemMarca;
          }
          return h;
        });
      });
      
      toast.info("🔄 Exclusão cancelada. Item restaurado.");
      
    } else {
      // MARCAR para remoção (tanto locais quanto do servidor)
      console.log("🗑️ Marcando item para remoção:", item);
      
      setItemsParaRemover(prev => [...prev, String(item)]);
      
      // Adicionar uma classe visual para mostrar que está marcado para remoção
      setHighlights(prevHighlights => {
        return prevHighlights.map(h => {
          if (String(h.id) === String(item)) {
            return { ...h, marcadoParaRemocao: true };
          }
          return h;
        });
      });
      
      const isLocal = String(item).startsWith('local_');
      const tipoItem = isLocal ? "local" : "servidor";
      
      toast.info(`🗑️ Item ${tipoItem} marcado para exclusão. Clique novamente para cancelar ou 'SALVAR' para confirmar.`);
    }
    
    setLocalEdits(true);
  };

  // Função para salvar todas as marcações de uma vez
  async function salvarTodasMarcacoes() {
    if (!localEdits && itemsParaRemover.length === 0) {
      toast.info("Não há alterações para salvar.");
      return;
    }
    
    setIsLoading(true);
    
    try {
      // Separar highlights locais de highlights já salvos
      const highlightsLocais = highlights.filter(h => 
        String(h.id).startsWith('local_') && 
        !h.marcadoParaRemocao
      );
      
      // NOVO: Marcações locais marcadas para remoção (devem ser simplesmente descartadas)
      const locaisParaRemover = highlights.filter(h => 
        String(h.id).startsWith('local_') && 
        h.marcadoParaRemocao
      );
      
      // CORREÇÃO: Incluir marcações que foram movidas (mesmo que sejam do servidor)
      const marcacoesMovidas = highlights.filter(h => 
        h.foiMovida && 
        !String(h.id).startsWith('local_') && 
        !h.marcadoParaRemocao
      );
      
      // IMPORTANTE: Identificar marcações locais que foram movidas 
      // (essas devem ser removidas do estado local após salvamento)
      const marcacoesLocaisMovidas = highlights.filter(h => 
        String(h.id).startsWith('local_') && 
        h.foiMovida && 
        !h.marcadoParaRemocao
      );
      
      // Filtrar apenas itens do servidor da lista de remoção
      const itensServidorParaRemover = itemsParaRemover.filter(id => !String(id).startsWith('local_'));
      
      console.log(`Salvando ${highlightsLocais.length} marcações locais`);
      console.log(`Descartando ${locaisParaRemover.length} marcações locais marcadas para remoção`);
      console.log(`Atualizando ${marcacoesMovidas.length} marcações movidas`);
      console.log(`Marcações locais movidas: ${marcacoesLocaisMovidas.length}`);
      console.log(`Removendo ${itensServidorParaRemover.length} marcações do servidor`);
      
      // Array para armazenar promessas de salvamento e remoção
      const promessas = [];
      
      // 1. Para cada highlight local, criar uma promessa de salvamento
      for (const highlight of highlightsLocais) {
        // Remover o ID local temporário e outras propriedades temporárias antes de enviar
        const { id, marcadoParaRemocao, foiMovida, ...highlightSemId } = highlight;
        
        // Preparar dados para enviar
        const data = {
          redacao_id: props.id,
          conteudo: JSON.stringify(highlightSemId),
        };
        
        // Adicionar promessa ao array
        promessas.push({
          tipo: 'adicao',
          promessa: api.post(`/salvar-correcao`, data)
        });
      }
      
      // 2. Para cada marcação movida, atualizar no servidor
      for (const highlight of marcacoesMovidas) {
        // Para marcações movidas, usar o endpoint de atualização
        const { id, marcadoParaRemocao, foiMovida, ...highlightLimpo } = highlight;
        
        const data = {
          id: id,
          position: highlightLimpo.position,
          content: highlightLimpo.content
        };
        
        promessas.push({
          tipo: 'atualizacao',
          promessa: api.put(`/atualizar-correcao`, data)
        });
      }
      
      // 3. Para cada item do servidor marcado para remoção, criar uma promessa de exclusão
      for (const itemId of itensServidorParaRemover) {
        // Tentar ambos os métodos para garantir que a exclusão funcione
        promessas.push({
          tipo: 'remocao',
          promessa: api.delete(`/deletar-correcao/${itemId}`).catch(() => 
            // Se DELETE falhar, tentar com PUT
            api.put(`/deletar-correcao/${itemId}`)
          )
        });
      }
      
      // Executar todas as promessas em paralelo
      const resultados = await Promise.allSettled(promessas.map(p => p.promessa));
      
      // Contar sucessos e falhas por tipo
      const sucessosAdicao = resultados
        .filter((r, i) => promessas[i].tipo === 'adicao' && r.status === 'fulfilled')
        .length;
        
      const sucessosAtualizacao = resultados
        .filter((r, i) => promessas[i].tipo === 'atualizacao' && r.status === 'fulfilled')
        .length;
        
      const sucessosRemocao = resultados
        .filter((r, i) => promessas[i].tipo === 'remocao' && r.status === 'fulfilled')
        .length;
        
      const falhasAdicao = resultados
        .filter((r, i) => promessas[i].tipo === 'adicao' && r.status === 'rejected')
        .length;
        
      const falhasAtualizacao = resultados
        .filter((r, i) => promessas[i].tipo === 'atualizacao' && r.status === 'rejected')
        .length;
        
      const falhasRemocao = resultados
        .filter((r, i) => promessas[i].tipo === 'remocao' && r.status === 'rejected')
        .length;
      
      const totalRemocoes = sucessosRemocao + locaisParaRemover.length; // Incluir locais "removidas"
      
      console.log(`Resultados: ${sucessosAdicao} adições, ${sucessosAtualizacao} atualizações e ${totalRemocoes} remoções com sucesso`);
      
      const falhasTotal = falhasAdicao + falhasAtualizacao + falhasRemocao;
      
      if (falhasTotal === 0) {
        // Se tudo for bem-sucedido, limpar todos os estados locais
        setItemsParaRemover([]);
        
        // CORREÇÃO: Limpar TODOS os localHighlights após salvamento bem-sucedido
        setLocalHighlights([]);
        
        setLocalEdits(false);
        
        // IMPORTANTE: Limpar COMPLETAMENTE todas as marcações antes de recarregar
        setHighlights([]);
        
        // IMPORTANTE: Aguardar mais tempo para garantir que o servidor processou
        await new Promise(resolve => setTimeout(resolve, 1500));
        
        // Recarregar todas as marcações do servidor (comportamento original)
        console.log("🔄 Recarregando marcações após salvamento bem-sucedido");
        await getCorrecaoNova();
        
        toast.success(
          `${sucessosAdicao} competência(s) salva(s), ${sucessosAtualizacao} atualizada(s) e ${totalRemocoes} removida(s) com sucesso!`
        );
      } else {
        toast.warning(
          `Algumas operações falharam. Salvar: ${sucessosAdicao}/${sucessosAdicao + falhasAdicao} | Atualizar: ${sucessosAtualizacao}/${sucessosAtualizacao + falhasAtualizacao} | Remover: ${sucessosRemocao}/${sucessosRemocao + falhasRemocao}`
        );
      }
    } catch (err) {
      console.error("Erro ao salvar marcações:", err);
      toast.error("Erro ao salvar as marcações. Por favor, tente novamente.");
    } finally {
      setIsLoading(false);
    }
  }

  const pegarRedacaoAnterior = () => {
    if (anterior) {
      window.location.href = `/corrigir/redacao/${anterior}`;
    }
  };

  const pegarRedacaoProxima = () => {
    if (proximo) {
      window.location.href = `/corrigir/redacao/${proximo}`;
    }
  };

  const pegarTodosAlunosComTema = async (tema_id, turma_id) => {
    try {
      const retorno = await api.get(
        `/getTurmaTemaRedacoes/${tema_id}/${turma_id}`
      );

      const lista = retorno.data || [];
      const len = lista.length;
      const index = lista.findIndex((item) => String(item.id) === String(id));

      /*
        Anterior/Próximo circulam entre as redações do mesmo tema e turma.

        Quando o grupo tem só a redação atual, o cálculo circular devolvia a
        própria redação nos dois lados: os botões ficavam habilitados (o id é
        truthy) e clicar navegava para a mesma URL, ou seja, não acontecia nada.
        Deixando undefined, `disabled={!anterior}` desabilita de verdade.
      */
      if (index === -1 || len < 2) {
        setAnterior(undefined);
        setProximo(undefined);

        if (index === -1) {
          console.warn(
            `Redação ${id} não encontrada entre as do tema ${tema_id} / turma ${turma_id}; navegação desabilitada.`
          );
        }
        return;
      }

      setAnterior(lista[(index + len - 1) % len].id);
      setProximo(lista[(index + 1) % len].id);
    } catch (err) {
      // sem isso a falha ficava invisível e os botões só apareciam desabilitados
      console.error("Erro ao buscar as redações do mesmo tema/turma:", err);
      setAnterior(undefined);
      setProximo(undefined);
    }
  };

  const pegarRedacaoDoAluno = async () => {
    try {
      // Verificar o ID atual na URL
      const currentPath = window.location.pathname;
      const currentId = currentPath.split('/').pop();
      
      // Usar o ID da URL em vez do ID das props
      const redacaoId = currentId || id;
      
      console.log(`Buscando dados da redação com ID: ${redacaoId}`);
      
      const retorno = await api.get(`/getRedacao/${redacaoId}`);

      console.log('retorno pegarRedacaoDoAluno ', retorno.data);
      if (retorno.data && retorno.data.length > 0) {
        const dados = retorno.data[0];
        const themeId = dados.theme_id;
        const turmaId = dados.turma_id;

        // Tema já vem do getRedacao
        const tema = dados.nome || '';

        // Buscar aluno e turma no endpoint de listagem de redações
        try {
          const listaRetorno = await api.get(`/redacoes/${themeId}/2/${turmaId}`);
          const redacaoEncontrada = listaRetorno.data?.find(r => String(r.id) === String(redacaoId));
          setRedacaoInfo({
            aluno: redacaoEncontrada?.aluno || '',
            turma: redacaoEncontrada?.turma || '',
            tema: redacaoEncontrada?.nome_redacao || tema,
          });
        } catch {
          setRedacaoInfo({ aluno: '', turma: '', tema });
        }

        /*
          Busca pelo id do aluno (não pelo nome) para não misturar homônimos.
          `limit` alto porque a lista é do aluno, não da prova inteira.
        */
        if (dados.user_id) {
          try {
            const outras = await api.get('/correcoes', {
              params: { alunoId: dados.user_id, limit: 200, status: 'todas_redacoes' },
            });

            /*
              Confere no cliente que as linhas são mesmo deste aluno. Um backend
              sem o parâmetro `alunoId` o ignora em silêncio e devolve a lista
              inteira — o seletor passaria a mostrar redações de outros alunos.
            */
            const doAluno = (outras.data?.data || []).filter(
              (r) => String(r.aluno_id) === String(dados.user_id)
            );

            if (doAluno.length === 0 && (outras.data?.data || []).length > 0) {
              console.warn('Backend ignorou o filtro alunoId; seletor desativado por segurança.');
            }

            setRedacoesDoAluno(doAluno);
          } catch (e) {
            console.error('Erro ao buscar as demais redações do aluno:', e);
            setRedacoesDoAluno([]);
          }
        }

        pegarTodosAlunosComTema(themeId, turmaId);
      }
    } catch (err) {
      console.error("Erro ao buscar redação do aluno:", err);
    }
  };

    async function getCorrecaoNova() {
    try {
      // CORREÇÃO: Usar o ID da URL em vez do ID das props para garantir consistência
      const currentPath = window.location.pathname;
      const currentId = currentPath.split('/').pop();
      const redacaoId = currentId || id;
      
      console.log(`Buscando correções para redação ID: ${redacaoId}`);
      
      const retorno = await api.get(`/pegar-correcao/${redacaoId}`);

      console.log("Carregando correções:", retorno.data?.length || 0);
      
      if (!retorno.data || retorno.data.length === 0) {
        console.log("Nenhuma correção encontrada");
        
        // CORREÇÃO CRÍTICA: Verificar se já existem marcações locais antes de limpar
        setHighlights(prevHighlights => {
          // Se já existem marcações (provavelmente locais), preservá-las
          if (prevHighlights.length > 0) {
            console.log(`⚠️ Preservando ${prevHighlights.length} marcações existentes`);
            return prevHighlights;
          }
          // Só limpar se realmente não há marcações de nenhum tipo
          return [];
        });
        
        // CORREÇÃO: Marcar como concluído mesmo quando não há correções
        setInitialLoadComplete(true);
        return;
      }

      // NOVO: Processar o novo formato JSON
      const valores = retorno.data.map((item) => {
        try {
          // Converter o formato novo para o formato esperado pelo react-pdf-highlighter
          return {
            id: item.id, // ID da correção
            content: {
              image: item.image_url || null,
              // Outros dados que possam ser necessários
            },
            position: {
              boundingRect: {
                x1: item.x1,
                y1: item.y1,
                x2: item.x2,
                y2: item.y2,
                width: item.width || 0,
                height: item.height || 0,
                pageNumber: item.b_rect_page_number || item.page_number || 1,
              },
              rects: item.rects?.rects || [],
              pageNumber: item.page_number || 1,
            },
            comment: {
              text: item.comment || "",
              emoji: item.emoji || "",
            },
            competencia: item.competencia,
            novoSistema: true, // Marcar como novo formato
            id_json: item.id_json, // Preservar o ID original do JSON
          };
        } catch (parseError) {
          console.error("Erro ao processar correção:", parseError);
          return null;
        }
      }).filter(Boolean);

      console.log(`${valores.length} correções carregadas do servidor`);
        
      // PROTEÇÃO CRÍTICA: Verificar se há marcações locais pendentes antes de sobrescrever
      setHighlights(prevHighlights => {
        // Se há marcações locais pendentes, mesclar com as do servidor
        const marcacoesLocaisPendentes = prevHighlights.filter(h => 
          String(h.id).startsWith('local_')
        );
        
        if (marcacoesLocaisPendentes.length > 0) {
          console.log(`🔄 Mesclando ${marcacoesLocaisPendentes.length} marcações locais com ${valores.length} do servidor`);
          return [...valores, ...marcacoesLocaisPendentes];
        } else {
          console.log(`✅ Aplicando ${valores.length} marcações do servidor (sem locais pendentes)`);
          return valores;
        }
      });
      
      console.log("✅ Marcações carregadas e aplicadas ao estado");
      
      // Marcar que o carregamento inicial foi concluído
      setInitialLoadComplete(true);
      
    } catch (err) {
      console.error("Erro ao carregar correções:", err);
      // Em caso de erro, não limpar se há marcações locais
      if (localHighlights.length === 0) {
        setHighlights([]);
      }
      // Mesmo em caso de erro, marcar como concluído para evitar loops
      setInitialLoadComplete(true);
    }
  }

  function updateHighlight(highlightId, position, content) {
    console.log(`🔄 Atualizando marcação ID: ${highlightId}`, { position, content });
    
    // Atualizamos apenas localmente, marcando que há mudanças pendentes
    setHighlights(prevHighlights => {
      const highlightEncontrado = prevHighlights.find(h => String(h.id) === String(highlightId));
      if (!highlightEncontrado) {
        console.warn(`⚠️ Marcação ${highlightId} não encontrada para atualização`);
        return prevHighlights;
      }
      
      const novoEstado = prevHighlights.map(highlight => {
        if (String(highlight.id) === String(highlightId)) {
          const marcacaoAtualizada = {
                ...highlight, 
                position: { ...highlight.position, ...position }, 
                content,
                // CORREÇÃO: Marcar que esta marcação foi movida
                foiMovida: true
          };
          console.log(`✅ Marcação ${highlightId} atualizada:`, marcacaoAtualizada);
          return marcacaoAtualizada;
        }
        return highlight;
      });
      
      console.log(`📋 Total de marcações após update: ${novoEstado.length}`);
      return novoEstado;
    });
    
    // Marcar que temos edições locais
    setLocalEdits(true);
    
    // CORREÇÃO DO BUG: Resetar os estados após um pequeno delay 
    // para garantir que aconteça apenas quando o usuário soltar a marcação
    setTimeout(() => {
      setSelectionBoxOpen(false);
      setAberto(false);
    }, 100);
    
    // Notification mais sutil para não distrair
    toast.info("Posição atualizada localmente.", { autoClose: 1500 });
  }

  const doCallback = useCallback((valor) => {
    setAberto(valor);
    // Aqui vamos atualizar também o estado que controla a caixa de seleção
    setSelectionBoxOpen(valor);
  }, []);

  function habilitarSelecao(event) {
    // Simplificar para o comportamento original
    return event.buttons;
  }

  useEffect(() => {
    document.body.classList.add("shidden");
    
    // Carregar correções com o novo sistema
    console.log("🏁 Inicializando componente - carregando correções");
    getCorrecaoNova();
    pegarRedacaoDoAluno();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Este useEffect é responsável por recarregar as correções quando o valor de att mudar
  useEffect(() => {
    // Só recarregar se o carregamento inicial já foi concluído
    if (initialLoadComplete) {
      console.log("🔄 att mudou, recarregando correções");
      
      // CORREÇÃO: Evitar recarregar e perder marcações locais
      // Verificar se já existem marcações locais antes de recarregar
      if (localHighlights.length === 0) {
        getCorrecaoNova();
      } else {
        console.log("⚠️ Ignorando recarga para preservar marcações locais existentes");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [att, initialLoadComplete]);

  // Adicionar uma função para monitorar mudanças na URL
  useEffect(() => {
    // Função para verificar se a URL mudou e recarregar os dados
    const checkURLChange = () => {
      const currentPath = window.location.pathname;
      const currentId = currentPath.split('/').pop();
      
      if (currentId !== String(id) && currentId) {
        console.log(`URL mudou para ID: ${currentId}, recarregando dados`);
        // Recarregar dados para o novo ID
        getCorrecaoNova();
        pegarRedacaoDoAluno();
      }
    };

    // Adicionar listener para detectar mudanças na navegação
    window.addEventListener('popstate', checkURLChange);
    
    return () => {
      window.removeEventListener('popstate', checkURLChange);
    };
  }, [id]);

  function showCoords(event) {
    var x = event.pageX;
    var y = event.pageY;
    var coor = "X coords: " + x + ", Y coords: " + y;
    console.log("coor ", coor);
    //document.getElementById("carregarPdf").innerHTML = coor;
  }

  // Restaurando a função original de salvar correção
  async function handleSaveCorrection() {
    console.log("handleSaveCorrection ", highlights);

    try {
      const data = {
        id: id,
        correcao: JSON.stringify(highlights),
      };

      await api.post("/salvarCorrecao", data);

      document.body.classList.remove("shidden");
      setShow(false);
      setFixo(false);
      toast.success("Correção de pdf salva com sucesso.");
    } catch (err) {
      console.error("Erro ao salvar correção:", err);
      toast.error("Erro ao salvar correção.");
    } finally {
      return false;
    }
  }

  useEffect(() => {
    if (initialLoadComplete) {
      toast.dismiss("pronto-correcao");
      toast.success(
        "✅ Pronto para correção! Você pode marcar com segurança.",
        {
          toastId: "pronto-correcao",
          autoClose: 4000,
          position: "top-right",
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialLoadComplete]);

  return (
    <>
      <style>
        {`
          /* CSS mínimo para não interferir no posicionamento */
          .PdfHighlighter {
            width: 100% !important;
          }
          
          .PdfHighlighter canvas {
            max-width: 100% !important;
          }
          
          /* Garantir que as marcações mantenham posição correta */
          .Highlight, .AreaHighlight {
            position: absolute !important;
          }
          
          /* Estilo para scrollbar customizada na sidebar */
          .sidebar-scroll::-webkit-scrollbar {
            width: 6px;
          }
          
          .sidebar-scroll::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
          }
          
          .sidebar-scroll::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;
          }
          
          .sidebar-scroll::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
          }
          
          /* Para dispositivos móveis */
          @media (max-width: 768px) {
            .conteudoPDF {
              flex-direction: column !important;
            }
            
            .conteudoPDF > div:first-child {
              width: 100vw !important;
              height: 45vh !important; /* Aumentar um pouco a altura da sidebar no mobile */
              max-height: 45vh !important;
              border-right: none !important;
              border-bottom: 2px solid #e0e0e0 !important;
            }
            
            .conteudoPDF > div:last-child {
              width: 100vw !important;
              height: 55vh !important;
            }
            
            /* No mobile, fazer os botões menores para economizar espaço */
            .mobile-compact-btn {
              padding: 8px 12px !important;
              font-size: 13px !important;
            }
            
            /* Texto menor na legenda para economizar espaço */
            .mobile-compact-text {
              font-size: 11px !important;
            }
          }
          
          /* Para telas muito pequenas */
          @media (max-width: 480px) {
            .conteudoPDF > div:first-child {
              height: 40vh !important;
              max-height: 40vh !important;
              padding: 10px !important;
            }
            
            .conteudoPDF > div:last-child {
              height: 60vh !important;
            }
          }
        `}
      </style>

      {/* Overlay centralizado de carregamento estilo modal retangular FINAL */}
      {!initialLoadComplete && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.45)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'all',
          userSelect: 'none',
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
            padding: '28px 32px 24px 32px',
            width: '400px',
            maxWidth: '90vw',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#1976d2',
              marginBottom: 10,
              textAlign: 'center',
              letterSpacing: 0.2,
              lineHeight: 1.3,
              wordBreak: 'break-word',
            }}>
              Carregando correções existentes...<br />Aguarde para começar a marcar.
            </div>
            <div style={{ marginTop: 12, display: 'flex', justifyContent: 'center', width: '100%' }}>
              <div style={{ transform: 'scale(1.1)' }}><SpinnerModal /></div>
            </div>
          </div>
        </div>
      )}

      {/* Overlay centralizado de salvamento estilo modal */}
      {isLoading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.45)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'all',
          userSelect: 'none',
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
            padding: '28px 32px 24px 32px',
            width: '400px',
            maxWidth: '90vw',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#28a745',
              marginBottom: 10,
              textAlign: 'center',
              letterSpacing: 0.2,
              lineHeight: 1.3,
              wordBreak: 'break-word',
            }}>
              SALVANDO MARCAÇÕES...
            </div>
            <div style={{ marginTop: 12, display: 'flex', justifyContent: 'center', width: '100%' }}>
              <div style={{ transform: 'scale(1.1)' }}><SpinnerModal /></div>
            </div>
          </div>
        </div>
      )}

      <Row>
        <Col xs={12} md>
          <p>
            <div
              className="btn btn-info"
              onClick={() => {
                document.body.classList.add("shidden");
                setShow(true);
                setFixo(true);
              }}
            >
              Abrir PDF para correção da redação
            </div>
          </p>
        </Col>
        <Col xs={12} md>
          <p className="text-right">
            {/* volta para a listagem com os filtros que o professor tinha montado */}
            <Link
              className="btn btn-success"
              to={history.location.state?.voltarPara || `/redacoes`}
            >
              Voltar para correções
            </Link>
          </p>
        </Col>
      </Row>

      <div
        className={`App conteudoPDF ${show}`}
        style={{ display: "flex", height: "100vh" }}
      >
        <div style={{
          width: "25vw",
          padding: "15px",
          borderRight: "1px solid #e0e0e0",
          backgroundColor: "#f8f9fa",
          boxShadow: "2px 0 10px rgba(0,0,0,0.1)",
          height: "100vh",
          overflowY: "auto", // Permitir scroll em toda a sidebar
          overflowX: "hidden"
        }} className="sidebar-scroll">
          <RButton
            className="btn-block mb-3"
            variant="warning"
            size="lg"
            style={{
              borderRadius: "8px",
              fontWeight: "bold",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
            }}
            onClick={handleClose}
          >
            CANCELAR CORREÇÃO PDF
          </RButton>
          
          <div className="navigation-buttons mb-3" style={{
            display: "flex",
            gap: "10px",
            marginBottom: "15px"
          }}>
            <RButton
              variant="info"
              className="flex-grow-1"
              style={{
                borderRadius: "6px",
                fontWeight: "500",
                boxShadow: "0 2px 4px rgba(0,0,0,0.08)"
              }}
              title={anterior ? "Correção anterior do mesmo tema e turma" : "Não há outra redação com este tema nesta turma"}
              onClick={pegarRedacaoAnterior}
              disabled={!anterior}
            >
              Redação anterior com este tema na turma
            </RButton>
            <RButton
              variant="info"
              className="flex-grow-1"
              style={{
                borderRadius: "6px",
                fontWeight: "500",
                boxShadow: "0 2px 4px rgba(0,0,0,0.08)"
              }}
              title={proximo ? "Próxima correção do mesmo tema e turma" : "Não há outra redação com este tema nesta turma"}
              onClick={pegarRedacaoProxima}
              disabled={!proximo}
            >
              Próxima redação com este tema na turma
            </RButton>
          </div>
          
          <div className="action-buttons mb-3" style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginBottom: "20px"
          }}>
            <RButton 
              variant="success" 
              size="lg"
              style={{
                borderRadius: "6px",
                fontWeight: "bold",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}
              onClick={handleSaveCorrection}
            >
              SALVAR CORREÇÃO PDF
            </RButton>
            
            <RButton 
              variant="primary"
              size="lg"
              style={{
                borderRadius: "6px",
                fontWeight: "bold",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                opacity: localEdits ? 1 : 0.7
              }}
              onClick={salvarTodasMarcacoes}
              disabled={isLoading || !localEdits}
            >
              {isLoading ? "SALVANDO MARCAÇÕES..." : "SALVAR TODAS AS MARCAÇÕES"}
            </RButton>
          </div>
          
          {!initialLoadComplete && (
            <div style={{ 
              marginBottom: "15px", 
              fontSize: "14px", 
              color: "#007bff",
              backgroundColor: "rgba(0, 123, 255, 0.1)",
              padding: "8px 12px",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}>
              <span style={{ fontWeight: "bold" }}>🔄</span>
              <span>Carregando correções existentes... Aguarde para começar a marcar.</span>
            </div>
          )}
          
          {localEdits && (
            <div style={{ 
              marginBottom: "15px", 
              fontSize: "14px", 
              color: "#f57c00",
              backgroundColor: "rgba(245, 124, 0, 0.1)",
              padding: "8px 12px",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}>
              <span style={{ fontWeight: "bold" }}>⚠️</span>
              <span>Você tem alterações não salvas</span>
            </div>
          )}
          
          {initialLoadComplete && !localEdits && !isLoading && (
            <div style={{ 
              marginBottom: "15px", 
              fontSize: "14px", 
              color: "#28a745",
              backgroundColor: "rgba(40, 167, 69, 0.1)",
              padding: "8px 12px",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}>
              <span style={{ fontWeight: "bold" }}>✅</span>
              <span>Pronto para correção! Você pode marcar com segurança.</span>
            </div>
          )}
          
          <h4 style={{
            borderBottom: "2px solid #dee2e6",
            paddingBottom: "10px",
            marginBottom: "15px",
            fontSize: "18px",
            fontWeight: "bold",
            color: "#495057"
          }}>
            Correção da redação - PDF
          </h4>

          {/* Informações da redação */}
          {(redacaoInfo.aluno || redacaoInfo.turma || redacaoInfo.tema) && (
            <div style={{
              backgroundColor: '#e8f4fd',
              border: '1px solid #bee5fd',
              borderRadius: '8px',
              padding: '10px 12px',
              marginBottom: '15px',
              fontSize: '13px',
              lineHeight: 1.6
            }}>
              {redacaoInfo.aluno && (
                <div><strong>👤 Aluno:</strong> {redacaoInfo.aluno}</div>
              )}
              {redacaoInfo.turma && (
                <div><strong>🏫 Turma:</strong> {redacaoInfo.turma}</div>
              )}
              {redacaoInfo.tema && (
                <div><strong>📝 Tema:</strong> {redacaoInfo.tema}</div>
              )}
            </div>
          )}

          {/* Alternar para outra redação do mesmo aluno sem voltar e refazer os filtros */}
          {outrasRedacoesDoAluno.length > 0 && (
            <div className="border rounded p-2 mb-3" style={{ fontSize: '12px' }}>
              <div className="font-weight-bold text-dark mb-2" style={{ fontSize: '13px' }}>
                <i className="fas fa-layer-group text-primary mr-1"></i>
                Outras redações deste aluno ({outrasRedacoesDoAluno.length})
              </div>

              {listaComprida && (
                <input
                  type="search"
                  className="form-control form-control-sm mb-2"
                  style={{ fontSize: '12px' }}
                  placeholder="Buscar por tema..."
                  value={buscaOutraRedacao}
                  onChange={(e) => setBuscaOutraRedacao(e.target.value)}
                  aria-label="Buscar entre as outras redações deste aluno"
                />
              )}

              <div style={listaComprida ? { maxHeight: '260px', overflowY: 'auto' } : undefined}>
                {outrasRedacoesFiltradas.map((r) => (
                  <button
                    key={r.id_redacao}
                    type="button"
                    className="btn btn-link text-left p-2 mb-1 w-100 border rounded"
                    style={{ fontSize: '12px', lineHeight: 1.35, textDecoration: 'none', whiteSpace: 'normal' }}
                    onClick={() => trocarDeRedacao(r.id_redacao)}
                    title={r.tema}
                  >
                    <span className="d-block text-dark">{r.tema || 'Tema não disponível'}</span>
                    <span className="d-block mt-1">
                      <span className={`badge ${r.status === 'corrigido' ? 'badge-success' : 'badge-warning'}`}>
                        {r.status === 'corrigido' ? 'Corrigida' : 'Pendente'}
                      </span>
                      {r.data && (
                        <span className="text-muted ml-2">
                          {new Date(r.data).toLocaleDateString('pt-BR')}
                        </span>
                      )}
                    </span>
                  </button>
                ))}

                {outrasRedacoesFiltradas.length === 0 && (
                  <small className="text-muted d-block p-1">
                    Nenhuma redação com esse tema.
                  </small>
                )}
              </div>
            </div>
          )}

          {/* Área das marcações - agora sem scroll próprio */}
          <div style={{
            marginBottom: "20px" // Espaço no final para scroll suave
          }}>
            <Sidebar
              tipo={tipo}
              removerItem={removerItem}
              highlights={highlights}
              itemsParaRemover={itemsParaRemover}
            />
          </div>
        </div>
        <div
          style={{
            height: "100vh",
            width: "75vw",
            position: "relative"
          }}
        >
          {/* Container simples que não interfere no posicionamento */}
          <div
            style={{
              width: "100%",
              height: "100%"
            }}
          >
            <PdfLoader ref={inputEl} url={pdf} beforeLoad={<Spinner />}>
              {(pdfDocument) => (
                <>
                  <PdfHighlighter
                    key={pdfKey}
                    onMouseMove={() => showCoords}
                    pdfDocument={pdfDocument}
                    enableAreaSelection={habilitarSelecao}
                    pdfScaleValue="page-width"
                    afterSelection={() => {
                      console.log("Seleção terminada");
                    }}
                    onSelectionFinished={(
                      position,
                      content,
                      hideTipAndSelection,
                      transformSelection
                    ) => {
                      setSelectionBoxOpen(true);
                      
                      console.log('📍 Posição original do react-pdf-highlighter:', position);
                      
                      return (
                      <>
                        <CaixaDeCorrecao
                          position={position}
                          content={content}
                          doCallback={doCallback}
                          addHighlight={addHighlight}
                          hideTipAndSelection={() => {
                            if (!selectionBoxOpen) {
                              hideTipAndSelection();
                            }
                          }}
                          onOpen={() => transformSelection}
                        />
                        <Tip />
                      </>
                      );
                    }}
                    highlightTransform={(
                      highlight,
                      index,
                      setTip,
                      hideTip,
                      viewportToScaled,
                      screenshot,
                      isScrolledTo
                    ) => {
                      const isTextHighlight = !Boolean(
                        highlight.content && highlight.content.image
                      );

                      const component = isTextHighlight ? (
                        <Highlight
                          isScrolledTo={isScrolledTo}
                          position={highlight.position}
                          comment={highlight.comment}
                        />
                      ) : (
                        <div className={`competencia_${highlight.competencia || 'nenhuma'}`}>
                          <AreaHighlight
                            isScrolledTo={isScrolledTo}
                            highlight={highlight}
                            onChange={(boundingRect) => {
                              console.log(
                                "boundingRect ",
                                viewportToScaled(boundingRect)
                              );
                              updateHighlight(
                                highlight.id,
                                {
                                  boundingRect: viewportToScaled(boundingRect),
                                },
                                { image: highlight.content.image }
                              );
                            }}
                          />
                        </div>
                      );

                      return (
                        <>
                          <Popup
                            popupContent={<HighlightPopup {...highlight} />}
                            onMouseOver={(popupContent) => {
                              if (!selectionBoxOpen) {
                              setTip(highlight, (highlight) => popupContent);
                              }
                            }}
                            onMouseOut={(popupContent) => {
                              if (!selectionBoxOpen) {
                                hideTip();
                              }
                            }}
                            key={index}
                            children={component}
                          />
                        </>
                      );
                    }}
                    highlights={highlights.filter(h => !h.marcadoParaRemocao)}
                  />
                </>
              )}
            </PdfLoader>
          </div>
        </div>
      </div>

      <Modal show={false} size="lg" className="grandao">
        <Modal.Header>
          <Modal.Title className="text-center" style={{ width: "100%" }}>
            Selecione uma competência
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>
            Antes de iniciar a correção, você precisa escolher a competência
            para iniciar.
          </p>
          <div
            className={`botao cor`}
            style={{
              backgroundColor: `${
                competencia === 1
                  ? "rgba(177,0,168, 1)"
                  : "rgba(177,0,168, 0.3)"
              }`,
              color: `${competencia === 1 ? "#fff" : "#000"}`,
              fontWeight: `${competencia === 1 ? "bold" : ""}`,
            }}
            onClick={() => {
              setCompetencia(1);
              setShow2(false);
            }}
          >
            {tipo == 1 ? "Modalidade culta da língua" : "Competência 1"}
          </div>
          <div
            className={`botao cor`}
            style={{
              backgroundColor: `${
                competencia === 2 ? "rgba(255,0,0,1)" : "rgba(255,0,0,0.3)"
              }`,
              color: `${competencia === 2 ? "#fff" : "#000"}`,
              fontWeight: `${competencia === 2 ? "bold" : ""}`,
            }}
            onClick={() => {
              setCompetencia(2);
              setShow2(false);
            }}
          >
            {tipo == 1 ? "Tipologia textual" : "Competência 2"}
          </div>
          <div
            className={`botao cor`}
            style={{
              backgroundColor: `${
                competencia === 3 ? "rgba(29,29,245, 1)" : "rgba(29,29,245,0.3)"
              }`,
              color: `${competencia === 3 ? "#fff" : "#000"}`,
              fontWeight: `${competencia === 3 ? "bold" : ""}`,
            }}
            onClick={() => {
              setCompetencia(3);
              setShow2(false);
            }}
          >
            {tipo == 1 ? "Argumentação" : "Competência 3"}
          </div>
          <div
            className={`botao cor`}
            style={{
              backgroundColor: `${
                competencia === 4 ? "rgba(10,208,0, 1)" : "rgba(10,208,0,0.3)"
              }`,
              color: `${competencia === 4 ? "#fff" : "#000"}`,
              fontWeight: `${competencia === 4 ? "bold" : ""}`,
            }}
            onClick={() => {
              setCompetencia(4);
              setShow2(false);
            }}
          >
            {tipo == 1 ? "Coesão e Estrura do período" : "Competência 4"}
          </div>
          <div
            className={`botao cor`}
            style={{
              backgroundColor: `${
                competencia === 5 ? "rgba(208,201,0, 1)" : "rgba(208,201,0,0.3)"
              }`,
              color: `${competencia === 5 ? "#fff" : "#000"}`,
              fontWeight: `${competencia === 5 ? "bold" : ""}`,
            }}
            onClick={() => {
              setCompetencia(5);
              setShow2(false);
            }}
          >
            {tipo == 1 ? "Adequação ao tema" : "Competência 5"}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CarregarPDF;
